module.exports = __webpack_public_path__ + "img/home_image_xuejiaren@2x.cd34154d.png";